import {configureStore} from '@reduxjs/toolkit'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {Middleware, PreloadedState, Reducer, Store} from 'redux'

interface StoreConfig<State, StoreExtraArgs> {
  reducers: Reducer
  initialData: PreloadedState<State>
  extraArguments: StoreExtraArgs
  middleware: Middleware[]
}

export const createReduxStore = <State, StoreExtraArgs>({
  reducers,
  initialData,
  extraArguments,
  middleware,
}: StoreConfig<State, StoreExtraArgs>) =>
  configureStore({
    reducer: reducers,
    preloadedState: initialData,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: extraArguments,
        },
      }).concat(middleware),
  })

export const subscribeToStateChanges = <State>(
  controller: ControllerParams['controllerConfig'],
  store: Store<State>,
) => {
  let state: State

  const onStateChange = () => {
    const newState = store.getState()

    if (newState !== state) {
      controller.setProps({state: newState})
      state = newState
    }
  }

  store.subscribe(onStateChange)
}
